var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.21 23.7812C27.4298 23.7812 25.168 26.043 25.168 28.8233C25.168 31.6035 27.4298 33.8653 30.21 33.8653C32.9907 33.8653 35.252 31.6035 35.252 28.8233C35.252 26.043 32.9902 23.7812 30.21 23.7812ZM30.21 31.3443C28.8197 31.3443 27.689 30.2136 27.689 28.8233C27.689 27.433 28.8197 26.3023 30.21 26.3023C31.6003 26.3023 32.731 27.433 32.731 28.8233C32.731 30.2137 31.6003 31.3443 30.21 31.3443Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9834 23.7812C10.2032 23.7812 7.94141 26.043 7.94141 28.8233C7.94141 31.6035 10.2032 33.8653 12.9834 33.8653C15.7637 33.8653 18.0255 31.6035 18.0255 28.8233C18.0255 26.043 15.7637 23.7812 12.9834 23.7812ZM12.9834 31.3443C11.5931 31.3443 10.4624 30.2136 10.4624 28.8233C10.4624 27.433 11.5931 26.3023 12.9834 26.3023C14.3734 26.3023 15.5045 27.433 15.5045 28.8233C15.5045 30.2137 14.3737 31.3443 12.9834 31.3443Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.605 9.35039C33.3907 8.92477 32.955 8.65625 32.4785 8.65625H25.8398V11.1773H31.7012L35.1335 18.0041L37.3865 16.8713L33.605 9.35039Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4284 27.6055H16.8906V30.1265H26.4284V27.6055Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20242 27.6055H4.83273C4.13648 27.6055 3.57227 28.1698 3.57227 28.8659C3.57227 29.5622 4.13656 30.1264 4.83273 30.1264H9.2025C9.89875 30.1264 10.463 29.5621 10.463 28.8659C10.463 28.1697 9.89867 27.6055 9.20242 27.6055Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7361 19.8995L37.2567 16.7062C37.0185 16.3986 36.6509 16.2187 36.2614 16.2187H27.1017V7.39523C27.1017 6.69898 26.5374 6.13477 25.8412 6.13477H4.83274C4.13648 6.13477 3.57227 6.69906 3.57227 7.39523C3.57227 8.09141 4.13656 8.6557 4.83274 8.6557H24.5806V17.4792C24.5806 18.1755 25.1449 18.7397 25.8411 18.7397H35.6441L37.4798 21.1044V27.6052H33.9924C33.2961 27.6052 32.7319 28.1695 32.7319 28.8657C32.7319 29.562 33.2962 30.1262 33.9924 30.1262H38.7403C39.4365 30.1262 40.0007 29.5619 40.0008 28.8657V20.6726C40.0008 20.3927 39.9075 20.1205 39.7361 19.8995Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11742 21.2188H3.31906C2.62281 21.2188 2.05859 21.783 2.05859 22.4792C2.05859 23.1755 2.62289 23.7397 3.31906 23.7397H9.11734C9.81359 23.7397 10.3778 23.1754 10.3778 22.4792C10.3779 21.783 9.81359 21.2188 9.11742 21.2188Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0168 16.2598H1.26047C0.564297 16.2598 0 16.8241 0 17.5203C0 18.2166 0.564297 18.7808 1.26047 18.7808H12.0168C12.713 18.7808 13.2773 18.2165 13.2773 17.5203C13.2773 16.8241 12.713 16.2598 12.0168 16.2598Z",
    fill: "#8DDCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0754 11.3027H3.31906C2.62281 11.3027 2.05859 11.867 2.05859 12.5632C2.05859 13.2595 2.62289 13.8237 3.31906 13.8237H14.0754C14.7716 13.8237 15.3359 13.2594 15.3359 12.5632C15.3359 11.867 14.7716 11.3027 14.0754 11.3027Z",
    fill: "#8DDCA4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.efbc64adc7220cfab30b1534b7328d19.svg";
export { ForwardRef as ReactComponent };